import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { updateRefreshDripCardsData } from "../../redux/dripData";
import { useDispatch } from "react-redux";

const CreatDripModal = ({ isOpen, onClose }) => {
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();

  const createCard = async () => {
    try {
      const response = await apiServiceHandler("POST", "api/drip-compaign", {
        title: title,
      });

      if (response.auth) {
        toastr.success(response?.message);
        setTitle("");
        dispatch(updateRefreshDripCardsData(true));
        onClose();
      } else {
        toastr.error(
          response.message ||
            "Failed to created drip campaign user. Please try again."
        );
        onClose();
      }
    } catch (error) {
      console.error("Failed to create a drip campaign. Please try again!");
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title
          style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
        >
          <span>Create Drip Campagin</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Name</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button className="send-invite__btn" onClick={createCard}>
          <span className="send-invite-button__label">Save</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreatDripModal;
